import { Flex, forwardRef } from '@cardboard-ui/react';
import React from 'react';
import TextEditor, { TextEditorProps } from './TextEditor';

export interface EditorProps extends TextEditorProps {}

export const Editor = forwardRef<EditorProps, 'div'>((props, ref) => {
  return (
    <Flex
      direction="column"
      align="center"
      flex={1}
      w="100%"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <TextEditor {...props} ref={ref} />
    </Flex>
  );
});

export default Editor;
